
import React, {useState, useEffect, useContext,useRef} from "react";
import {useHistory} from "react-router-dom";
import classNames from "classnames";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";

import {
    Grid,
    FormGroup,
    FormControl,
    ControlLabel,
    Tooltip,
    OverlayTrigger
} from "react-bootstrap";

import ReactTable from "components/ReactTable/ReactTable.js";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationAlert from "react-notification-alert";
import rest from "../../API/api";
import { UserLoginContext } from "../../context/UserLoginContext";
import { CollectionsContext } from "../../context/CollectionsContext";
import { authenticatedFetch } from "../../services/authService";

const CohortCollectionsTable = () => {
    const [collectionsState, setCollectionsState] = useContext(CollectionsContext);
    const [userState, setUserState] = useContext(UserLoginContext);
    const [alert, setalert] = React.useState(null);
    const notificationAlertRef = useRef(null);
    const history = useHistory();
    const [data, setData] = React.useState([]);

    // Update table data whenever cohort collections change
    useEffect(() => {
        if (userState.status && collectionsState.cohortCollections && Array.isArray(collectionsState.cohortCollections)) {
            const tableData = collectionsState.cohortCollections.map((theCollection, i) => {
                return {
                    id: theCollection._id,
                    Title: theCollection.Title,
                    Description: theCollection.Description,

                    actions: (
                        // we've added some custom button actions
                        <div className="actions-right">
                            {/* use this button to add a edit kind of action */}
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"edit_" + i}>Edit Collection</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        setCollectionsState((prevcollectionsState) => ({
                                            ...prevcollectionsState,
                                            cohortCollection: theCollection}));
                                        let tURL = "/admin/editcohortcollection/";
                                        await history.push(tURL);
                                    }}
                                    color="warning"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-pencil"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            {/* use this button to remove the data row */}
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"delete_" + i}>Delete Collection</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        const collectionIndex = collectionsState.cohortCollections.findIndex(c => c._id === theCollection._id);
                                        if (collectionIndex !== -1) {
                                            _deleteCollectionAlert(theCollection._id, collectionsState.cohortCollections, collectionIndex);
                                        }
                                    }}
                                    color="danger"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-simple-remove"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            {/* use this button to Add Collection Images the collection on this row */}
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"addimage_" + i}>Add a Collection Image</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        //Set the current collection state for use in /admin/addcohortimage/
                                        setCollectionsState((prevcollectionsState) => ({
                                            ...prevcollectionsState,
                                            cohortCollection: theCollection
                                        }));
                                        //Call /admin/addcohortimage/:collectionId route and use this state to add an image to this collection
                                        //Lets load all the images for this collection into the context
                                        try {
                                            let tempURL = rest.cohortImages + '/' + theCollection._id;
                                            const response = await authenticatedFetch(tempURL, {
                                                method: 'GET',
                                                headers: {
                                                    'Content-Type': 'application/json'
                                                }
                                            });
                                            const cohortImagesData = await response.json();
                                            setCollectionsState((prevcollectionsState) => ({
                                                ...prevcollectionsState,
                                                cohortImages: cohortImagesData
                                            }));
                                            //Call /admin/addcohortimage/:collectionId route and use this state to add an image to this collection
                                            let tURL = "/admin/addcohortimage/" + theCollection._id + "?from=collections";
                                            await history.push(tURL);
                                        } catch (error) {
                                            console.error('Error fetching cohort images:', error);
                                            notify("danger", error.message || 'Failed to fetch cohort images.');
                                        }
                                    }}
                                    color="info"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-image-02"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"editimage_" + i}>Edit Collection Images</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        //Set the current collection state for use in /admin/editcohortimages/
                                        setCollectionsState((prevcollectionsState) => ({
                                            ...prevcollectionsState,
                                            cohortCollection: theCollection
                                        }));
                                        //Call /admin/editcohortimages/ route and use this state to add an image to this collection
                                        //Lets load all the images for this collection into the context
                                        try {
                                            let tempURL = rest.cohortImages + '/' + theCollection._id;
                                            const response = await authenticatedFetch(tempURL, {
                                                method: 'GET',
                                                headers: {
                                                    'Content-Type': 'application/json'
                                                }
                                            });
                                            const cohortImagesData = await response.json();
                                            setCollectionsState((prevcollectionsState) => ({
                                                ...prevcollectionsState,
                                                cohortImages: cohortImagesData
                                            }));
                                            let tURL = "/admin/editcohortimages/" + theCollection._id;
                                            await history.push(tURL);
                                        } catch (error) {
                                            console.error('Error fetching cohort images:', error);
                                            notify("danger", error.message || 'Failed to fetch cohort images.');
                                        }
                                    }
                                }
                                    color="warning"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-vector"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>

                        </div>
                    )
                };
            });
            setData(tableData);
        }
    }, [collectionsState.cohortCollections, userState.status]);

    const notify = (type, message) => {
        const options = {
            place: "tc",
            message: <div>{message}</div>,
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    useEffect(() => {
        const getCollections = async () => {
            try {
                const response = await authenticatedFetch(rest.cohortCollections, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                const cohortCollectionsData = await response.json();
                setCollectionsState((collectionsState) => ({
                    ...collectionsState,
                    cohortCollections: cohortCollectionsData
                }));
            } catch (error) {
                console.error('Error fetching collections:', error);
                notify("danger", error.message || 'Failed to fetch collections.');
            }
        };
        getCollections(); // run it, run it
    }, []);

    const _delete_collection = async (id) => {
        try {
            let tempURL = rest.cohortCollections + '/' + id;
            const response = await authenticatedFetch(tempURL, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Delete failed:', errorData);
                throw new Error(errorData.message || 'Failed to delete collection');
            }

            const collectionsData = await response.json();
            return collectionsData;
        } catch (error) {
            console.error('Error deleting collection:', error);
            notify("danger", error.message || 'Failed to delete collection.');
            throw error;
        }
    };

    const _deleteCollectionAlert = async (id,collections,index) => {
        try {
            let tempURL = rest.cohortImages + '/' + id;
            const response = await authenticatedFetch(tempURL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const cohortImagesData = await response.json();
            if(cohortImagesData.length === 0) {
                setalert(
                    <SweetAlert
                        warning
                        showCancel
                        confirmBtnText="Yes, delete it!"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure?"
                        style={{display: "block"}}
                        onConfirm={async () => {
                            try {
                                await _delete_collection(id);

                                // Re-fetch collections to refresh the table
                                const response = await authenticatedFetch(rest.cohortCollections, {
                                    method: 'GET',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                });
                                const cohortCollectionsData = await response.json();
                                setCollectionsState((prevcollectionsState) => ({
                                    ...prevcollectionsState,
                                    cohortCollections: cohortCollectionsData
                                }));

                                setalert(null);
                                notify("success", "Collection has been deleted successfully!");
                            } catch (error) {
                                setalert(null);
                            }
                        }}
                        onCancel={() => {
                            setalert(null);
                        }}
                    >
                        Are you sure you want to delete this collection?
                    </SweetAlert>
                );
            }
            else {
                setalert(
                        <SweetAlert
                            danger
                            confirmBtnText="Ok"
                            confirmBtnBsStyle="danger"
                            cancelBtnBsStyle="default"
                            title="Collection is not empty!"
                            style={{display: "block"}}
                            onConfirm={() => {
                                setalert(null);
                            }}
                            onCancel={() => {
                                setalert(null);
                            }}
                        >
                            Please delete all child images for this collection!
                        </SweetAlert>
                    );
                return (cohortImagesData);
            }
        } catch (error) {
            console.error('Error checking collection images:', error);
            notify("danger", error.message || 'Failed to check collection images.');
        }
    };
    if (userState.status) {
        return (
            <>
                <div className="rna-container">
                    <NotificationAlert ref={notificationAlertRef} />
                </div>
                <div className="content">
                    <Col md={8} className="ml-auto mr-auto">
                        <h2 className="text-center">Cohort Image Gallery</h2>
                        <p className="text-center">
                            This is a list cohort images organized into collections
                        </p>
                    </Col>
                    <Row className="mt-5">
                        <Col xs={12} md={12}>
                            <Card>
                                <CardHeader>
                                    <Row>
                                        <Col md="6">
                                            <CardTitle tag="h4">Cohort Image Collections</CardTitle>
                                        </Col>
                                        <Col md="6" className="text-right">
                                            <Button
                                                color="info"
                                                onClick={() => history.push("/admin/addcohortcollection")}
                                                className="animation-on-hover"
                                            >
                                                <i className="tim-icons icon-simple-add"/> Add Collection
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <ReactTable
                                        data={data}
                                        filterable
                                        columns={[
                                            {
                                                Header: "Title",
                                                accessor: "Title"
                                            },
                                            {
                                                Header: "Description",
                                                accessor: "Description"
                                            },
                                            {
                                                Header: "Actions",
                                                accessor: "actions",
                                                sortable: false,
                                                filterable: false
                                            }
                                        ]}
                                        defaultPageSize={5}
                                        showPaginationTop
                                        showPaginationBottom={false}
                                        className="-striped -highlight"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {alert}
                </div>
            </>

        );
    }

    else {
        //alert("You must be logged in and have an active subscription to access this page!");
        history.push("/admin/dashboard");
        return(null);
    }
};

export default CohortCollectionsTable;
